export default "__VITE_ASSET__b0d1f6d7__"